import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import {
    Row,
    Col,
    Input,
    Label,
    Button,
    Card,
    CardBody,
    Form,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { Container } from "reactstrap"
import httprequester from '../../lib/httprequester'
import { Typeahead } from 'react-bootstrap-typeahead';

//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { Editor } from '@tinymce/tinymce-react';

class EditAnimasi extends Component {
    constructor(props) {
        super(props);
        this.state = {
            basic: false,
            listAnimasi: [],
            listCategory: [],
            listSpesialis: [],
            listMolekul: [],
            listPenyakit: [],
            listPenulis: [],
            animasiID: '',
            animasiJudul: '',
            animasiPenulis: '',
            animasiPenyakit: '',
            animasiMolekul: '',
            animasiSpesialis: '',
            animasiKonten: '',
            animasiGambar: '',
            animasiVideo: '',
            animasiCreatedby: '',
            status: '',
            chspepe: false,
            chspe: false,
            chspem: false,
            chspep: false,
            name: ''
        };
    }

    componentDidMount() {
        let x = JSON.parse(localStorage.getItem('user'))
        if (x) {
            this.setState({
                name: x.admin_name
            })
        }
        let router = window.location.href;
        let routerSplitter = router.split("/");
        let id = routerSplitter[5];
        let final = id.replace(/\%20/g, ' ');

        // console.log("animasiID => ", routerSplitter)

        this.setState({
            animasiID: final,
            status: routerSplitter[6]
        });

        this.getDetailAnimasi(final);
        this.getCategory();
        this.getLOV();
    }

    static propTypes = {
        history: PropTypes.object.isRequired
    }

    back = () => {
        this.props.history.push(`/animasi-penggunaan-obat`)
    }

    getCategory = () => {
        httprequester.get('category/getall', {
            success: async function (response) {

                console.log("resCat => ", response)
                if (response.data.message == "success") {
                    this.setState({
                        listCategory: response.data.detailMessage
                    })
                }
            }.bind(this),
            error: function (err) {
                console.log("error", err)
            }.bind(this)

        })
    }

    getLOV = () => {
        httprequester.get('artikel/lov', {
            success: async function (response) {

                console.log("resLOV => ", response)
                if (response.data.message == "success") {
                    let datapenyakit = []
                    response.data.detailPenyakit.forEach((v, key) => {
                        // console.log('v',v);
                        datapenyakit.push({
                            penyakit_id: v.penyakit_id,
                            penyakit_name: v.penyakit_name == null ? '-' : v.penyakit_name
                        })
                    })
                    this.setState({
                        listSpesialis: response.data.detailSpecialist,
                        listMolekul: response.data.detailMolekul,
                        listPenyakit: datapenyakit,
                        listPenulis: response.data.detailPenulis
                    })
                }
            }.bind(this),
            error: function (err) {
                console.log("error", err)
            }.bind(this)

        })
    }

    getDetailAnimasi = (value) => {
        console.log("idnnya => ", this.state.animasiID)
        let body = {
            "animasi_id": value
        }

        console.log("body =>", body)
        httprequester.postarticle('animasi/detail', body, {
            success: async function (response) {
                let data = []
                let cek = response.data.settings.datarows
                console.log("res => ", cek)
                if (response.data.message == "success") {
                    cek.forEach(async (v, key) => {
                        await data.push({
                            animasi_molekul: v[0],
                            created_at: v[1],
                            animasi_penyakit: v[4],
                            created_by: v[5],
                            animasi_content: v[6],
                            animasi_penulis: v[7],
                            animasi_thumbnail: v[8],
                            animasi_status: v[10],
                            animasi_slug: v[11],
                            animasi_spesialis: v[12],
                            animasi_id: v[15],
                            animasi_title: v[16],
                            animasi_video: v[17]
                        })
                        this.setState({
                            animasiID: v[15],
                            animasiJudul: v[16],
                            animasiPenulis: v[7],
                            animasiPenyakit: v[4],
                            animasiMolekul: v[0],
                            animasiSpesialis: v[12],
                            animasiKonten: v[6],
                            animasiGambar: v[8],
                            animasiVideo: v[17],
                            animasiCreatedby: v[5]
                        })
                    })
                    this.setState({
                        listAnimasi: data
                    })
                }
            }.bind(this),
            error: function (err) {
                console.log("error", err)
            }.bind(this)

        })
    }

    saveAnimasi = () => {
        let slugLower = this.state.animasiJudul.toLowerCase();
        let slugRep = slugLower.replace(/\s/g, '-');

        let body = {
            "animasi_id": this.state.animasiID,
            "animasi_penyakit": this.state.animasiPenyakit.toString(),
            "animasi_penyakit_search": this.state.animasiPenyakit.toString(),
            "animasi_penulis": this.state.animasiPenulis.toString(),
            "animasi_penulis_search": this.state.animasiPenulis.toString(),
            "animasi_molekul": this.state.animasiMolekul.toString(),
            "animasi_molekul_search": this.state.animasiMolekul.toString(),
            "animasi_spesialis": this.state.animasiSpesialis.toString(),
            "animasi_spesialis_search": this.state.animasiSpesialis.toString(),
            "animasi_title": this.state.animasiJudul,
            "animasi_title_search": this.state.animasiJudul,
            "animasi_slug": slugRep,
            "animasi_content": this.state.animasiKonten,
            "animasi_thumbnail": this.state.animasiGambar,
            "animasi_video": this.state.animasiVideo,
            "animasi_status": this.state.status,
            "created_by": this.state.name
        }

        console.log("body =>", body)
        this.setState({
            prosess: true
        })
        httprequester.postarticle('animasi/update', body, {
            success: async function (response) {
                console.log("res => ", response)
                if (response.data.message == "success") {
                    this.setState({
                        basic: true,
                        prosess: false
                    })
                }
            }.bind(this),
            error: function (err) {
                console.log("error", err)
            }.bind(this)

        })
    }

    handleChangeJudul(e) {
        // let data = []
        // data.push({
        //     animasiJudul: e[0].animasiJudul
        // })

        this.setState({
            listAnimasi: { animasiJudul: e[0].animasiJudul }
            // animasiMolekul: listAnimasi.animasiJudul
        })
        console.log("INIT M", e);
    }

    handleChangePenulis(e) {
        this.setState({
            animasiPenulis: e
        })
        console.log("INIT N", e);
    }

    handleChangeSpesialis(e) {
        this.setState({
            animasiSpesialis: e
        })
        console.log("INIT S", e);
    }

    handleChangeMolekul(e) {
        this.setState({
            animasiMolekul: e
        })
        console.log("INIT M", e);
    }

    handleChangePenyakit(e) {
        let data = []
        data.push({
            animasiPenyakit: e
        })

        this.setState({
            animasiPenyakit: listAnimasi.animasiPenyakit
        })
        console.log("INIT P", e);
    }

    handleEditorChange = (e) => {
        console.log(
            'Content was updated:',
            e.target.getContent()
        );
        this.setState({
            animasiKonten: e.target.getContent()
        })
    }

    render() {
        const option = this.state.listSpesialis.map(o => o.specialist_name)
        const optionMolekul = this.state.listMolekul.map(o => o.molekul_name)
        const optionPenyakit = this.state.listPenyakit.map(o => o.penyakit_name)
        const optionPenulis = this.state.listPenulis.map(o => o.penulis_name)
        console.log("judul => ", this.state.listAnimasi[0])
        return (
            <React.Fragment>
                <div className="page-content">
                    <MetaTags>
                        <title>Edit Petunjuk Penggunaan Obat</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Petunjuk Penggunaan Obat" breadcrumbItem="Edit Petunjuk Penggunaan Obat" />

                        {this.state.basic ? (
                            <SweetAlert
                                success
                                title="Petunjuk Penggunaan Obat berhasil di simpan"
                                onConfirm={() => this.back()}
                            ></SweetAlert>
                        ) : null}

                        {this.state.prosess ? (
                            <SweetAlert title="proses simpan ..." showConfirm={false} >
                            </SweetAlert>
                        ) : null}

                        {this.state.listAnimasi.map(function (animasi, index) {
                            return <Col key={index}>
                                <Row>
                                    <Col lg={12}>
                                        <Card>
                                            <CardBody>
                                                <Form>

                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-firstname-Input">Judul Petunjuk Penggunaan Obat</Label>
                                                        <Input
                                                            id="animasiJudul"
                                                            type="input"
                                                            placeholder={animasi.animasi_title}
                                                            // onChange={(e) => this.handleChangeJudul(e)}
                                                            onChange={(e) => this.setState({ animasiJudul: e.target.value })}
                                                            value={this.state.animasiJudul}
                                                        />
                                                    </div>

                                                    <Row>
                                                        <Col md={4}>
                                                            <div className="mb-3">
                                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                    <Label for="exampleSpesialisasi">
                                                                        Penulis
                                                                    </Label>
                                                                    <a className="font-ri-color" style={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={() => this.setState({ chspepe: !this.state.chspepe })} >ubah</a>
                                                                </div>
                                                                {/* <Label htmlFor="formrow-firstname-Input">Penulis</Label> */}
                                                                {(!this.state.chspepe) ?
                                                                    <Input
                                                                        name="judul"
                                                                        disabled
                                                                        type="text"
                                                                        value={this.state.animasiPenulis} />
                                                                    : <Typeahead
                                                                        // allowNew
                                                                        id="basic-typeahead-multiple"
                                                                        multiple
                                                                        placeholder="Pilih Penulis"
                                                                        labelKey="name"
                                                                        options={optionPenulis}
                                                                        onChange={(e) => this.handleChangePenulis(e)}
                                                                        value={this.state.animasiPenulis}
                                                                    />
                                                                }
                                                            </div>
                                                        </Col>
                                                        <Col md={4}>
                                                            <div className="mb-3">
                                                                <Label htmlFor="formrow-email-Input">URL Gambar Thumbnail</Label>
                                                                <Input
                                                                    id="animasiThumbnail"
                                                                    type="input"
                                                                    placeholder={animasi.animasi_thumbnail}
                                                                    onChange={(e) => this.setState({ animasiGambar: e.target.value })}
                                                                    value={this.state.animasiGambar}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col md={4}>
                                                            <div className="mb-3">
                                                                <Label htmlFor="formrow-email-Input">URL Video</Label>
                                                                <Input
                                                                    id="animasiVideo"
                                                                    type="input"
                                                                    placeholder={animasi.animasi_video}
                                                                    onChange={(e) => this.setState({ animasiVideo: e.target.value })}
                                                                    value={this.state.animasiVideo}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col lg={4}>
                                                            <div className="mb-3">
                                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                    <Label for="exampleSpesialisasi">
                                                                        Spesialisasi
                                                                    </Label>
                                                                    <a className="font-ri-color" style={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={() => this.setState({ chspe: !this.state.chspe })} >ubah</a>
                                                                </div>
                                                                {/* <Label htmlFor="formrow-InputCity">Spesialis</Label> */}
                                                                {(!this.state.chspe) ?
                                                                    <Input
                                                                        name="judul"
                                                                        disabled
                                                                        type="text"
                                                                        value={this.state.animasiSpesialis} required />
                                                                    : <Typeahead
                                                                        id="basic-typeahead-multiple"
                                                                        multiple
                                                                        placeholder="Pilih Spesialis"
                                                                        labelKey="name"
                                                                        options={option}
                                                                        onChange={(e) => this.handleChangeSpesialis(e)}
                                                                        value={this.state.animasiSpesialis}
                                                                    />
                                                                }
                                                            </div>
                                                        </Col>
                                                        <Col lg={4}>
                                                            <div className="mb-3">
                                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                    <Label for="exampleSpesialisasi">
                                                                        Molekul
                                                                    </Label>
                                                                    <a className="font-ri-color" style={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={() => this.setState({ chspem: !this.state.chspem })} >ubah</a>
                                                                </div>
                                                                {/* <Label htmlFor="formrow-InputState">Molekul</Label> */}
                                                                {(!this.state.chspem) ?
                                                                    <Input
                                                                        name="judul"
                                                                        disabled
                                                                        type="text"
                                                                        value={this.state.animasiMolekul} required />
                                                                    : <Typeahead
                                                                        id="basic-typeahead-multiple"
                                                                        multiple
                                                                        placeholder="Pilih Molekul"
                                                                        labelKey="name"
                                                                        options={optionMolekul}
                                                                        onChange={(e) => this.handleChangeMolekul(e)}
                                                                        value={this.state.animasiMolekul}
                                                                    />
                                                                }
                                                            </div>
                                                        </Col>

                                                        <Col lg={4}>
                                                            <div className="mb-3">
                                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                    <Label for="exampleSpesialisasi">
                                                                        Penyakit
                                                                    </Label>
                                                                    <a className="font-ri-color" style={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={() => this.setState({ chspep: !this.state.chspep })} >ubah</a>
                                                                </div>
                                                                {/* <Label htmlFor="formrow-InputZip">Penyakit</Label> */}
                                                                {(!this.state.chspep) ?
                                                                    <Input
                                                                        name="judul"
                                                                        disabled
                                                                        type="text"
                                                                        value={this.state.animasiPenyakit} required />
                                                                    : <Typeahead
                                                                        id="basic-typeahead-multiple"
                                                                        multiple
                                                                        placeholder="Pilih Penyakit"
                                                                        labelKey="name"
                                                                        options={optionPenyakit}
                                                                        onChange={(e) => this.handleChangePenyakit(e)}
                                                                        value={this.state.animasiPenyakit}
                                                                    />
                                                                }

                                                            </div>
                                                        </Col>
                                                    </Row>

                                                </Form>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row style={{ paddingTop: 10 }}>
                                    <Col xs="12" md="12">
                                        <Card>
                                            <CardBody>
                                                <Form method="post">
                                                    <Editor
                                                        apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
                                                        initialValue={animasi.animasi_content}
                                                        init={{
                                                            height: 500,
                                                            menubar: false,
                                                            plugins: [
                                                                'advlist autolink lists link image charmap print preview anchor',
                                                                'searchreplace visualblocks code fullscreen',
                                                                'insertdatetime media table paste code help wordcount'
                                                            ],
                                                            toolbar: 'undo redo | formatselect | ' +
                                                                'bold italic forecolor backcolor | alignleft aligncenter ' +
                                                                'alignright alignjustify | bullist numlist outdent indent lineheight | ' +
                                                                'removeformat link',
                                                            content_style: 'body { font-family:Poppins,Arial,sans-serif; }',
                                                            line_height_formats: '0.2 0.4 0.6 0.8 1 1.2 1.4 1.6 2',
                                                        }}
                                                        onChange={this.handleEditorChange}
                                                    />
                                                </Form>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        }.bind(this))}
                        <Row style={{ paddingTop: 10 }}>
                            <Col xs="12" md="12">
                                <Card>
                                    <Button type="submit" className="btn btn-primary w-md" onClick={() => this.saveAnimasi()}>
                                        Submit Animasi Penggunaan Obat
                                    </Button>
                                </Card>
                            </Col>
                        </Row>
                        {/* <Row md="10" style={{ paddingTop: 8, justifyContent: "end", alignItems: "end" }}>
                            <Button color="danger" onClick={() => this.saveanimasi()}>
                                Submit Artikel
                            </Button>
                        </Row> */}
                    </Container>
                </div>
            </React.Fragment >
        )
    }
}

export default EditAnimasi;
